export const withLogarithmicScale = dataArray => {
  if (!dataArray || !dataArray.length) {
    return null;
  }
  return dataArray.map(count => {
    const percentage = (Math.log10(count + 1) * 0.25).toFixed(2);
    return Math.min(percentage, 1) * 100;
  });
};
